import {atom, useAtom} from 'jotai'
import {useEffect, useState} from 'react'
import { JobCard } from "@/interfaces/api/models";

const dataAtom = atom({});
export const readWriteAtom = atom(
    (get: any) => get(dataAtom),
    (get: any, set: any, id: string, newVal: any) => {
        const data = get(dataAtom);
        const updatedData = { ...data, [id]: newVal };
        set(dataAtom, updatedData)
    }
)


// Global password-change prompt state (triggered post-login if weak)
export const passwordChangePromptAtom = atom<{ open: boolean; title?: string; message?: string; }>({
    open: false,
    title: undefined,
    message: undefined
})

const filterStatesAtom = atom({})
export const readWriteFilterStatesAtom = atom(
    (get: any) => get(filterStatesAtom),
    (get: any, set: any, filterName: string, newVal: any) => {
        const data = get(filterStatesAtom);
        const updatedData = { ...data, [filterName]: newVal };
        set(filterStatesAtom, updatedData)
    }
)

export const openModalsAtom = atom<string[]>([])

/**
 * Registers this component instance in the shared open-overlay stack while `open` is true, and
 * reports whether it is currently the topmost registered layer.
 *
 * ScDrawer uses `isTopMost` to gate its outside-click/Escape closing so a click or Escape key only
 * closes whichever drawer/modal is actually on top - without this, a drawer would also close itself
 * when the click/key was really meant for a modal or drawer stacked on top of it (e.g. a preferences
 * drawer opened over a parent drawer).
 */
export const useOverlayLayer = (open: boolean) => {
    const [uid] = useState(() => crypto.randomUUID())
    const [openModals, setOpenModals] = useAtom(openModalsAtom)

    useEffect(() => {
        if (!open) return
        setOpenModals((current) => [...current.filter((x) => x !== uid), uid])
        return () => setOpenModals((current) => current.filter((x) => x !== uid))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return {isTopMost: openModals.length === 0 || openModals[openModals.length - 1] === uid}
}

export const inventoryDrawerAtom = atom<{
    selectedInventory: any | null;
}>({
    selectedInventory: null
})

export const savedInventoryAtom = atom<any | null>(null)

// Atom for tracking job drag operations
export const jobDragStateAtom = atom<{
    isDragging: boolean;
    job: JobCard | null;
}>({
    isDragging: false,
    job: null
})

export const justCompletedSetupAtom = atom<boolean>(false)

export const forceInitialSetupAtom = atom<boolean>(false)

export const permissionsVersionAtom = atom<number>(0)

// Global confetti trigger. `count` is a counter (not a boolean) so repeated
// triggers always restart the animation cleanly — increment it to fire the
// confetti drop. `message`, when provided, also shows a centered modal while
// the confetti falls (and briefly after).
export interface ConfettiFireState {
    count: number;
    message?: string | null;
}

export const confettiFireAtom = atom<ConfettiFireState>({ count: 0, message: null })
